module.exports = __webpack_public_path__ + "media/images/favicon/favicon-96x96-0366149c650401f97d03108d3856b180.png";